module.exports = __webpack_public_path__ + "img/restaurant-circle-white.9f711bfa.svg";